
import { defineComponent, computed, ref, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { Check, Document, Refresh } from '@element-plus/icons-vue'

export default defineComponent({
  components: { Check, Document, Refresh },
  setup() {
    const store = useStore()
    
    const state = reactive({
      theme: store.state.settings.theme,
      sideTheme: store.state.settings.sideTheme
    })
    
    // 使用计算属性实现双向绑定
    const visible = computed({
      get: () => store.state.settings.showSettings,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    })
    
    const fixedHeaderModel = computed({
      get: () => store.state.settings.fixedHeader,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        })
      }
    })
    
    const topNavModel = computed({
      get: () => store.state.settings.topNav,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'topNav',
          value: val
        })
        if (!val) {
          store.dispatch('app/toggleSideBarHide', false)
          store.commit("SET_SIDEBAR_ROUTERS", store.state.permission.defaultRoutes)
        }
      }
    })
    
    const tagsViewModel = computed({
      get: () => store.state.settings.tagsView,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        })
      }
    })
    
    const sidebarLogoModel = computed({
      get: () => store.state.settings.sidebarLogo,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        })
      }
    })
    
    const dynamicTitleModel = computed({
      get: () => store.state.settings.dynamicTitle,
      set: (val) => {
        store.dispatch('settings/changeSetting', {
          key: 'dynamicTitle',
          value: val
        })
      }
    })
    
    const themeChange = (val: string) => {
      store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      })
      state.theme = val
    }
    
    const handleTheme = (val: string) => {
      store.dispatch('settings/changeSetting', {
        key: 'sideTheme',
        value: val
      })
      state.sideTheme = val
    }
    
    const saveSetting = () => {
      const loading = ElLoading.service({
        text: '正在保存到本地，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      const cache = {
        topNav: topNavModel.value,
        tagsView: tagsViewModel.value,
        fixedHeader: fixedHeaderModel.value,
        sidebarLogo: sidebarLogoModel.value,
        dynamicTitle: dynamicTitleModel.value,
        sideTheme: state.sideTheme,
        theme: state.theme
      }
      
      localStorage.setItem('layout-setting', JSON.stringify(cache))
      
      setTimeout(() => {
        loading.close()
      }, 1000)
    }
    
    const resetSetting = () => {
      const loading = ElLoading.service({
        text: '正在清除设置缓存并刷新，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      localStorage.removeItem('layout-setting')
      
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
    
    return {
      ...toRefs(state),
      visible,
      fixedHeaderModel,
      topNavModel,
      tagsViewModel,
      sidebarLogoModel,
      dynamicTitleModel,
      themeChange,
      handleTheme,
      saveSetting,
      resetSetting
    }
  }
})
